import React from 'react';
import { Star } from 'lucide-react';
export function TopProofBar() {
  return <div className="bg-brand-navy text-white py-1.5 px-3 text-center border-b border-brand-navyLight/40" data-id="element-255">
      <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] md:text-xs font-bold leading-tight" data-id="element-256">
        <div className="flex items-center text-brand-yellow" data-id="element-257">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 md:w-3 md:h-3 fill-current" data-id="element-258" />)}
        </div>
        <span className="uppercase tracking-wide" data-id="element-259">
          <span className="text-brand-yellow font-black" data-id="element-260">+1.200 docentes</span>{' '}
          y capacitadores ya tienen sus clases listas
        </span>
      </div>
    </div>;
}